import React from 'react';
import cx from 'classnames';
import { Button, Typography } from '@material-ui/core';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

export const PanelWelcome = ({ className }) => {
  const styles = useStyles();
  const { handleSignUpClick } = useHandlers();

  return (
    <div
      className={cx(
        styles.root,
        'flex flex-row items-center',
        'px-4 py-2',
        'bg-neutral-white',
        'border border-neutral-gray rounded-md',
        className
      )}
    >
      <Typography className="text-lg">
        <span className="font-bold">Welcome to Anyword!</span> Create a free account to write
        stellar copy that works 10x better
      </Typography>

      <div className="flex-1" />

      <Button
        className="ml-2 rounded-md"
        onClick={handleSignUpClick}
        variant="contained"
        color="secondary"
      >
        Sign up
      </Button>
    </div>
  );
};
